import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { Shape2, Shape2Icon, Shape2Theme } from '../Shape2/Shape2';

import './NumeratedTileListItem.css';

export interface NumeratedTileListItemProps {
    cls?: string;
    itemId: string;
    index: number;
    isDisabled: boolean;
    onDelete: (id: string) => void;
    children: React.ReactNode;
}

const blockClass = 'numerated-tile-list-item';

export class NumeratedTileListItem extends React.PureComponent<
    NumeratedTileListItemProps
> {
    render() {
        const { cls, index, children, isDisabled } = this.props;

        return (
            <div className={classNames(blockClass, cls)}>
                <div className={Bem.cls(blockClass, 'index')}>{index}.</div>

                <div className={Bem.cls(blockClass, 'content')}>{children}</div>

                <Shape2
                    cls={Bem.cls(blockClass, 'delete')}
                    width={16}
                    height={16}
                    icon={Shape2Icon.trashbin}
                    theme={Shape2Theme.light}
                    hoverable={true}
                    disabled={isDisabled}
                    onClick={this.onDelete}
                />
            </div>
        );
    }

    private onDelete = () => {
        const { itemId, onDelete, isDisabled } = this.props;

        if (isDisabled) {
            return;
        }

        onDelete(itemId);
    };
}
